export default __webpack_public_path__ + "static/img-small2-9e64b59689a1c7539a6f6be2c4e8c35a.jpg";